import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Loadable from 'react-loading-overlay'

import TasksDetails from '../tasksdetails'

@observer(['companies', 'globals'])
export default class Tasks extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loadableState: true
    }

    this.loadTasks(this.props.companyId) 
  }

  loadTasks(companyId) {
    this.props.companies.loadCompanyTasks(companyId, () => {
      this.setState({
        loadableState: false
      })
    })
  }

  render() {
    return (
      <div>
        <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
          <TasksDetails data={ this.props.companies.tasks } companyId={ this.props.companyId } taskId={ this.props.taskId } />
        </Loadable>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/company/tasks.js